import { NotFoundError } from '@raydiant/api-client-js';

export default function handleDeviceDeleted<U, T extends Promise<U>>(
  promise: T,
  onDeleted: () => void,
): Promise<U> {
  return promise.catch((err) => {
    if (err instanceof NotFoundError) {
      onDeleted();
    }
    throw err;
  });
}
